import { AllSubscriptions, getServiceName, SubscriptionService, SubscriptionServiceId } from "@eres/greenlistapi/entities";
import Strings from "@my-dld/assets/strings";
import React, { Component } from "react";
import { handleDataUpdate, IGreenListForm, IGreenListFormProps, IGreenListFormState } from "./Base";

interface Props extends IGreenListFormProps {
	subscriptions: SubscriptionService[];
	onServiceRemoved: ( service: SubscriptionService ) => void;
	onServiceSelected: ( service: SubscriptionService ) => void;
	onServiceDetails: ( service: SubscriptionService ) => void;
}

interface State extends IGreenListFormState {
	hasAll: boolean;
}

export class SubscriptionServicesForm extends Component<Props, State> implements IGreenListForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		const hasAll = props.subscriptions.find( x => x.ServiceTypeId === SubscriptionServiceId.ALL ) != null;
		this.state = {
			hasAll: hasAll,
			isValid: this.isValid( false ),
		};
	}

	onServiceRemove = ( sub: SubscriptionService ) => {
		const ps = this.props.subscriptions;
		let s: SubscriptionService[] = ps.filter( x => x.ServiceTypeId !== sub.ServiceTypeId );
		const cb = () => {
			this.props.onServiceRemoved( sub );
		};
		const hasAll = s.find( x => x.ServiceTypeId === SubscriptionServiceId.ALL ) != null;
		this.setState( {
			hasAll: hasAll,
		}, () => {
			cb();
		} );
	};
	onServiceSelect = ( sub: SubscriptionService, isSelected: boolean ) => {
		const ps = this.props.subscriptions;
		let s: SubscriptionService[] = [];
		let cb = () => {
		};
		if ( isSelected ) {
			s = sub.ServiceTypeId === SubscriptionServiceId.ALL ? [ sub ] : [ ...ps, sub ];
			cb = () => {
				this.props.onServiceSelected( sub );
			};
			const hasAll = s.find( x => x.ServiceTypeId === SubscriptionServiceId.ALL ) != null;
			this.setState( {
				hasAll: hasAll,
			}, () => {
				cb();
			} );
		} else {
			this.props.onServiceDetails( sub );
		}
	};

	componentDidMount() {
		this.props.onUpdated( this.isValid( false ) );
	}

	render() {
		const { hasAll } = this.state;
		const { subscriptions } = this.props;
		return (
			<div className="green-list-service-selection">
				<h5 className="greenlist-title">
					<span>{ Strings.gl_sub_service_title }</span>
					<small>{ Strings.gl_sub_service_info }</small>
				</h5>
				<div className="custom-checkbox-control">
					{ AllSubscriptions.map( value => {
							const isSelected = subscriptions.find( x => x.ServiceTypeId === value.ServiceTypeId ) != null;
							return <SubscriptionItem
								isSelected={ isSelected }
								disableOthers={ hasAll }
								key={ value.ServiceTypeId } sub={ value }
								onSelect={ this.onServiceSelect }
								onRemove={ this.onServiceRemove }
							/>;
						}
					) }
				</div>
			</div>
		);
	}

	isValid( _isUserAction: boolean ): boolean {
		return this.props.subscriptions.length > 0;
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		const oldData = this.getData( prevProps );
		const newData = this.getData( this.props );
		handleDataUpdate( oldData, newData, prevState, this );
	}

	getData = ( props: Props = this.props ) => {
		return {
			subscriptions: props?.subscriptions
		};
	};
}

type SubscriptionItemParams = {
	sub: SubscriptionService;
	onSelect: ( sub: SubscriptionService, isSelected: boolean ) => void;
	onRemove: ( sub: SubscriptionService ) => void;
	disableOthers: boolean;
	isSelected: boolean;
};

export function SubscriptionItem( props: SubscriptionItemParams ) {
	const { sub, onSelect, onRemove, disableOthers, isSelected } = props;
	const handleChange = ( _event: React.ChangeEvent<HTMLInputElement> ) => {
		onSelect( sub, !isSelected );

	};
	const removeMe = ( event: React.MouseEvent<HTMLElement> ) => {
		event.preventDefault();
		onRemove( sub );
	};
	return <>
		<div className="custom-checkbox">
			<input
				checked={ isSelected }
				disabled={ sub.ServiceTypeId !== SubscriptionServiceId.ALL && disableOthers }
				onChange={ handleChange }
				type="checkbox" id={ "sub-" + sub.ServiceTypeId }
				name="customRadio"
				className="custom-control-input"/>
			<label className="custom-control-label" htmlFor={ "sub-" + sub.ServiceTypeId }>
				{ getServiceName( sub ) }
				<span>
                    <i className="fa fa-check"/>
					{ sub.ServiceTypeId !== SubscriptionServiceId.ALL && <i className="fa fa-angle-right"/> }
                </span>
			</label>
			<span className="btn-greenlist-trash">
                { isSelected && <i className="fa fa-trash" onClick={ removeMe }/> }
            </span>
		</div>
	</>;
}
